import { api } from './client';
import { Product as FrontendProduct, Category, Subcategory } from '../data/products';

export interface ResellerProduct {
  id: string;
  category_id: number;
  subcategory_id: number;
  brand: string;
  ref: string;
  name: string;
  name_en: string;
  description?: string;
  description_en?: string;
  price: number;
  reseller_price: number;
  currency: string;
  stock: number;
  moq: number;
  quote_threshold: number;
  features: string[];
  features_en: string[];
  images: string[];
  variants: { sizes?: string[]; colors?: string[] };
  norm_ids: number[];
  sector_ids: number[];
  bestseller: boolean;
  badge?: string;
  badge_en?: string;
  is_active: boolean;
  category?: {
    id: number;
    slug: string;
    name_fr: string;
    name_en: string;
  };
  subcategory?: {
    id: number;
    slug: string;
    name_fr: string;
    name_en: string;
    category_id: number;
  };
  created_at?: string;
  updated_at?: string;
}

export interface ProductListResponse {
  products: ResellerProduct[];
  total: number;
}

export interface ProductsQueryParams {
  category?: string;
  subcategory?: string;
  sector?: string;
  brand?: string;
  norm?: string;
  price_min?: number;
  price_max?: number;
  stock_only?: boolean;
  purchase_mode?: string;
  search?: string;
  sort_by?: string;
  sort_order?: string;
  page?: number;
  limit?: number;
}

export function transformResellerProduct(apiProduct: ResellerProduct): FrontendProduct {
  const categoryMap: Record<string, Category> = {
    vetements: 'vetements',
    epi: 'epi',
    batteries: 'batteries',
  };
  
  const categorySlug = apiProduct.category?.slug || '';
  const subcategorySlug = apiProduct.subcategory?.slug || '';
  
  return {
    id: String(apiProduct.id),
    category: (categoryMap[categorySlug] || 'vetements') as Category,
    subcategory: (subcategorySlug.replace(/-/g, '') || 'vestes') as Subcategory,
    sector: [],
    name: apiProduct.name,
    nameEn: apiProduct.name_en || apiProduct.name,
    brand: apiProduct.brand,
    ref: apiProduct.ref,
    price: apiProduct.reseller_price || apiProduct.price,
    currency: apiProduct.currency,
    stock: apiProduct.stock,
    moq: apiProduct.moq,
    quoteThreshold: apiProduct.quote_threshold,
    norm: [],
    description: apiProduct.description || '',
    descriptionEn: apiProduct.description_en || apiProduct.description || '',
    images: apiProduct.images,
    variants: apiProduct.variants,
    features: apiProduct.features,
    featuresEn: apiProduct.features_en,
    bestseller: apiProduct.bestseller,
    badge: apiProduct.badge,
    badgeEn: apiProduct.badge_en,
  };
}

export const resellerProductsApi = {
  getProducts: (params: ProductsQueryParams = {}) =>
    api.get<ProductListResponse>('/reseller/products', params),

  getProduct: (id: string) =>
    api.get<ResellerProduct>(`/reseller/products/${id}`),

  getBestsellers: (limit: number = 10) =>
    api.get<ProductListResponse>('/reseller/products/bestsellers', { limit }),

  getCategories: () =>
    api.get<{ categories: any[] }>('/reseller/products/categories'),

  getFiltersMeta: () =>
    api.get<any>('/reseller/products/filters-meta'),
};
